module.exports = __webpack_public_path__ + "img/tqAppGif.7becc64e.gif";